module.exports = __webpack_public_path__ + "../resources/img/ic_others_gray950.3244e901.svg";